import { createUseFoundationHook, createUseSurfaceHook, Size, Tone } from '@cld/design-system-foundations';
import { ChipProps, ChipSize } from './types';

const foundationSizeToChipSize: Record<Size, ChipSize> = {
  xxs: 'xxs',
  xs: 'xxs',
  sm: 'sm',
  md: 'sm',
  lg: 'md',
  xl: 'md',
  xxl: 'md',
};

const chipSizeToInnerFoundationSize: Record<ChipSize, Size> = {
  md: 'sm',
  sm: 'xxs',
  xxs: 'xs',
};

const surfaceToneToChipTone: Record<Tone, Tone> = {
  subtle: 'solid',
  solid: 'subtle',
};

export const { useFoundation } = createUseFoundationHook<Pick<ChipProps, 'size'>>(
  ({ size }) => ({ size: foundationSizeToChipSize[size] }),
  ({ size }) => ({ size: chipSizeToInnerFoundationSize[size] }),
  { size: 'md' }
);

export const { useSurface } = createUseSurfaceHook<Pick<ChipProps, 'variant' | 'tone'>>(
  ({ variant, tone }) => ({ variant, tone: surfaceToneToChipTone[tone] }),
  ({ variant, tone }) => ({ variant, tone }),
  { variant: 'secondary', tone: 'solid' }
);
